import { FC } from 'react'
import styled from 'styled-components'

// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-responsive-images
import { Clock, ProgressiveAsset, TypeStyleBodySmall } from '@syconium/little-miss-figgy'

import { NextLink } from '../../../../../app/_components/navigation/NextLink'
import { BadgesSection } from '../../../../../app/_components/pages/product-pages/ProductPage/ProductHighlights/BadgesSection/index'
import { useCartDialog } from '../../../../../app/_providers/CartProvider.client'
import { useLocalization } from '../../../../../app/_providers/LocalizationProvider.client'
import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { useGoogleTagManager } from '../../../../../lib/hooks/useGoogleTagManager'
import { CartItem } from '../../../../../types/figs'
import { AddEmbroideryUpsellButton } from '../../CartEmbroideryUpsell/AddEmbroideryButton'
import { filterPropertiesToDisplay } from '../../utils'
import { CartItemAttributes } from '../CartItemAttributes/CartItemAttributes'

import { Body, Details, FitDescription, ImagePlaceholder, OptionsText, Title, Top } from './styles'

export const KitCartItem: FC<{
  cartItem: CartItem
  eventCategory: 'minicart' | 'cart'
}> = ({ cartItem, eventCategory }) => {
  const {
    colorDisplayValue,
    effectivePrice,
    finalSale,
    fitDisplayValue,
    fullPrice,
    shopifyProductId,
    image,
    productGroupHandle,
    productType,
    properties,
    sizeDisplayValue,
    sku,
    title,
    variantId,
    isLowInventory,
    urlPath,
  } = cartItem
  const { region } = useLocalization()
  const { pages, cart: miniCartCopy } = useTranslation()

  const { close: closeCartDialog } = useCartDialog()
  const { pushProductClick } = useGoogleTagManager()
  const propertiesToDisplay = filterPropertiesToDisplay(properties)

  const linkHref = urlPath

  // pull out the property for final sale because there is a separate badge with different formatting
  // for final sale than other properties, but we still want the line item prop for the checkout page
  const { [miniCartCopy.finalSale]: finalSaleProp, ...otherPropertiesToDisplay } =
    propertiesToDisplay

  //is the product itself finalSale (socks) or is the kit marked as final Sale
  const isFinalSaleBadgeVisible = finalSale || finalSaleProp

  return (
    <Body data-testid='cart-kit-item' data-cart-item-id={properties._setUid}>
      <Top>
        <NextLink
          href={linkHref}
          onClick={() => {
            pushProductClick({
              variant: {
                category: productType,
                externalParentId: shopifyProductId,
                currencyType: region.currency,
                discountPrice: effectivePrice,
                handle: productGroupHandle,
                price: fullPrice,
                shopifyId: variantId,
                sku,
              },
              list: `${eventCategory}-cart`,
            })
            closeCartDialog()
          }}
        >
          {image.url ? (
            <ProgressiveAsset.Image src={image.url} alt={title} />
          ) : (
            <ImagePlaceholder />
          )}
        </NextLink>

        <Details>
          <div>
            <Title>{title}</Title>

            <OptionsText>
              {sizeDisplayValue}
              {fitDisplayValue && <FitDescription>&nbsp;• {fitDisplayValue}</FitDescription>}
              &nbsp;• {colorDisplayValue}
            </OptionsText>

            <CartItemAttributes attributes={otherPropertiesToDisplay} />

            <AddEmbroideryUpsellButton cartItem={cartItem} />

            {isFinalSaleBadgeVisible && <BadgesSection badges={[miniCartCopy.finalSale]} />}
          </div>
        </Details>
      </Top>
      {isLowInventory && (
        <LowInventoryTypography>
          <Clock />
          {pages.product.lowInventoryWarning}
        </LowInventoryTypography>
      )}
    </Body>
  )
}

const LowInventoryTypography = styled(TypeStyleBodySmall)`
  color: ${o => o.theme.color.text.caution.on.background};
  display: flex;
  align-items: center;
  gap: ${o => o.theme.spacing(2)};
  margin: ${o => o.theme.spacing(6, 0, 0, 0)};
`
